import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Box } from "@mui/material";
import { Cart } from "../components/Cart/Cart";
import { Header } from "../components/Header/Header";
import { AppProviders } from "./AppProviders";
import { AppRoutes } from "./AppRoutes";

function AppContent() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <>
      <Header onCartClick={() => setCartOpen(true)} />
      <Cart open={cartOpen} onClose={() => setCartOpen(false)} />
      {/* <CookieConsent policyPath="/legal/cookies" /> */}

      <Box sx={{ flexGrow: 1 }}>
        <AppRoutes />
      </Box>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppProviders>
        <AppContent />
      </AppProviders>
    </Router>
  );
}
